import { gql } from "apollo-boost"

export const CREATE_ACTIVITY_SCHEDULE = gql`
  mutation createSchedule($scheduleData: CreateActivitySchedule!, $activityId: ID!) {
    CreateActivityScheduleByID(scheduleData: $scheduleData, activityId: $activityId) {
      id
      createdAt
      place
      startTime
      endTime
      scheduledAt
    }
  }
`